import React, { useContext } from "react";
import PropTypes from "prop-types";
import { ShareContext } from "components/context/share/ShareContext";
import TooltipButton from "components/utility/tooltip/TooltipButton";
import { v1 as uuidv1 } from "uuid";
import ButtonIcon from "components/utility/button/ButtonIcon";

export const ContentPageShareExplanation = () => {
	const data = useContext(ShareContext);
	const { explanationData, updateState } = data;
	const openMobileShareExplanation = () => {
		updateState({ mobileTooltipFlag: true });
	};
	const onKeyup = (e) => {
		const key = e.which || e.keyCode || 0;
		if (key === 13 || key === 32) {
			openMobileShareExplanation();
		}
	};
	const getShareExplantionContent = (contentList) => {
		let content = "";
		if (typeof contentList === "string") {
			return contentList;
		} else {
			contentList.forEach((el) => {
				content =
					content + `<p class='content-page-share-explanation-title'>${el.title}</p>${el.content}`;
			});
			return content;
		}
	};
	return (
		<div
			className={`content-page-share-explanation ${
				explanationData ? "" : "content-page-share-explanation-invisible"
			}`}
			role="button"
			tabIndex="0"
			onClick={() => {
				openMobileShareExplanation();
			}}
			onKeyUp={(e) => {
				onKeyup(e);
			}}
		>
			<TooltipButton
				id={uuidv1()}
				content={getShareExplantionContent(explanationData.description)}
				position="top"
				tooltipPosition="right"
				clickable={true}
				className="content-page-share-explanation-button"
				dataLabel={explanationData.label}
			>
				<ButtonIcon type="info-popup-circle" key="info-popup-circle" isButton={false} />
			</TooltipButton>
		</div>
	);
};

ContentPageShareExplanation.prototype = {
	onClick: PropTypes.func
};
export default {
	ContentPageShareExplanation
};
